var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value,"disabled":_vm.disabled,"placeholder":"请选择","clearable":"","filterable":""},on:{"change":(v) => {
      this.$emit('change', v);
      this.$emit('input', v);
    }}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.OrgId,attrs:{"label":item.StaName,"value":item.OrgId}},[_vm._v(" "+_vm._s(item.StaName)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }